import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { ComprehensiveRequestsService } from "src/services/comprehensive-requests.service";
import { Lightbox } from "ngx-lightbox";
import { RateCard } from "src/models/rate-card";
import { OwlOptions } from "ngx-owl-carousel-o";
import { Helpers } from "src/helpers/helpers";
import { AccountService } from "src/services/account.service";
import { MatLegacySnackBar as MatSnackBar } from "@angular/material/legacy-snack-bar";
import { CareplusOrdersService } from "src/services/careplus-orders.service";
import { StorageService } from "src/services/storage.service";
import { DocumentType } from "src/models/careplus-documents";

@Component({
  selector: "app-careplus-order-detail",
  templateUrl: "./careplus-order-detail.component.html",
  styleUrls: ["./careplus-order-detail.component.css"],
})
export class CareplusOrderDetailComponent implements OnInit {
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    responsive: {
      0: {
        items: 1,
      },
    },
    nav: false,
  };
  isAgencyUser: boolean = false;
  document: {
    membershipCardUrl: SafeResourceUrl | null;
    receiptCopyUrl: SafeResourceUrl | null;
    policyCopyUrl: SafeResourceUrl | null;
    policyWordingUrl: SafeResourceUrl | null;
  } = {
    membershipCardUrl: null,
    receiptCopyUrl: null,
    policyCopyUrl: null,
    policyWordingUrl: null,
  };
  isAgencyHr: boolean = false;
  isCareplusReq: boolean = false;
  order?: Partial<RateCard>;
  memberDisplayedColumns: string[] = [
    "name",
    "relationType",
    "gender",
    "dateOfBirth",
    "idType",
    "memberId",
  ];

  constructor(
    private lightbox: Lightbox,
    private route: ActivatedRoute,
    private _careplusOrderService: CareplusOrdersService,
    private sanitizer: DomSanitizer,
    private helper: Helpers,
    private accountService: AccountService,
    private router: Router,
    private snackBar: MatSnackBar,
    private storageService: StorageService,
  ) {
    const obj = this.helper.getDecodedAccessToken(
      localStorage.getItem("token"),
    );
    if (
      obj.type.indexOf("LEVEL 0") === 0 ||
      obj.type.indexOf("LEVEL 1") === 0 ||
      obj.type.indexOf("LEVEL 2") === 0
    ) {
      this.isAgencyUser = true;
      this.accountService.getAccount().subscribe((data) => {
        if (!data.activated) {
          this.helper.logout();
          this.router.navigate(["/"]);
          this.snackBar.open(
            "Your account is not active, please contact admin.",
            "Close",
            {
              duration: 3000,
            },
          );
        }
      });
    }

    const navigation = this.router.getCurrentNavigation();
    this.isAgencyHr = navigation?.extras?.state?.["isAgencyHr"] ?? false;
  }

  ngOnInit() {
    const id = this.route.snapshot.paramMap.get("id");
    this.getOrder(id);
    this.isAgencyHr = history.state?.isAgencyHr;
    this.isCareplusReq = history.state?.isCareplusReq ?? false;
  }

  openCarImage(car: string): void {
    const src = car;
    const thumb = car;
    const album = {
      src,
      caption: "",
      thumb,
    };
    this.lightbox.open([album], 0);
  }

  loadDocument(url: string, type: DocumentType) {
    this.storageService.getImage(url).subscribe((response) => {
      const blob = new Blob([response], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(blob);

      const safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl);
      this.document[type] = safeUrl;
    });
  }

  getOrder(id: any) {
    this._careplusOrderService.getOrderById(id).subscribe((res) => {
      this.order = res;
      if (res.documents) {
        this.loadDocument(res.documents[0], DocumentType.MembershipCard);
        this.loadDocument(res.documents[1], DocumentType.Receipt);
        this.loadDocument(res.documents[2], DocumentType.Policy);
        this.loadDocument(res.documents[3], DocumentType.PolicyWording);
      }
    });
  }
}
